var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video-js",attrs:{"id":`mingle_video`,"poster":_vm.returnMedia(_vm.thumbnail),"playsinline":"","controls":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }